import { ModuleFE_DataInputLog } from './ModuleFE_DataInputLog.js';
export const ModulePackFE_DataInputLogDB = [ModuleFE_DataInputLog];
//# sourceMappingURL=module-pack.js.map